var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(!_vm.isSimplePage)?_c('NavbarCp'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),(!_vm.isSimplePage)?_c('AsideCp'):_vm._e(),_vm._v(" "),(!_vm.isSimplePage)?_c('FooterCp'):_vm._e(),_vm._v(" "),_c('Loading',{class:{ show: this.isLoading }}),_vm._v(" "),_c('notifications')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c9ca8f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 